import VideoPlayer from '../Video/VideoPlayer';
import RenderElectionWidgetIframe from '../RenderElectionWidgetIframe';
import ArticleshowBriefs from '../../routes/articleshow_v2/components/common/ArticleshowBriefs/WithArticleshowBriefs';
import { TOI_VIDEO_API_KEY } from '../../constants';

/**
 * Configurations for widget to be rendered in iframe
 */
export default {
  VIDEOPLAYER: {
    Widget: VideoPlayer,
    defaultprops: {
      apiKey: TOI_VIDEO_API_KEY,
      inline: true,
      wrapper: 'masterVideoPlayer',
      manuallytriggerClick: true,
      config: {
        config: {
          video: {
            id: '',
          },
          contEl: 'masterVideoPlayer',
          controls: {
            dock: false,
            // dock: {
            //   type: 'native',
            //   dismissible: true,
            // },
          },
          player: {
            pageSection: '',
            autoPlay: true,
            fallbackMute: true,
            playsInline: true,
            mute: true,
            skipAd: false,
            volume: 70,
            playlistUrl: '',
            playlist: true,
            isAMP: true,
            scrollBehaviour: {
              inViewPercent: 80,
              dock: true,
              autoPlay: true,
            },
          },
        },
      },
      wrapperHeight: '100vh',
    },
    classes: '',
    styles: {},
  },
  ARTICLESHOWBRIEFS: {
    Widget: ArticleshowBriefs,
    defaultprops: {},
    classes: 'iframe',
  },
  ELECTIONWDT: {
    Widget: RenderElectionWidgetIframe,
    defaultprops: {
      hideSharing: null,
      hideHeading: null,
      hideLiveblog: null,
      hideStarCandidate: null,
      isWapView: null,
      isExitPoll: null,
      hideInfocus: null,
    },
    classes: '',
    styles: {},
  },
};
